/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, } from 'react';
import styles from '../SemenProcessing/SemenProcessing.module.css';
import Grid from '@mui/material/Grid';
import { ReactComponent as SpermCountRefrenceImage } from '../../../assets/SVG/spermcount_reference.svg';
import { ReactComponent as SpermMotalityRefImg } from '../../../assets/SVG/refernce_motality.svg';
import { ReactComponent as AbnormalImg } from '../../../assets/SVG/abnormal.svg';
import { ReactComponent as NormalImg } from '../../../assets/SVG/normalFlag.svg';

import { ReactComponent as NormalSpermCount } from '../../../assets/SVG/normalsperm_count.svg';
import { ReactComponent as LowSpermCount } from '../../../assets/SVG/lowsperm_count.svg';
import { ReactComponent as HighSpermCount } from '../../../assets/SVG/highsperm_count.svg';

import { ReactComponent as NormalSpermMotility } from '../../../assets/SVG/normalforwordsperm_motality.svg';
import { ReactComponent as AbNormalSpermMotility } from '../../../assets/SVG/abnormalsperm_motality.svg';

// import { ReactComponent as NormalSpermMorphology } from '../../../assets/SVG/normalsperm_morphology.svg';
// import { ReactComponent as AbNormalSpermMorphology } from '../../../assets/SVG/abnormalsperm_morphology.svg';
// import { ReactComponent as SpermMorphologyRefImg } from '../../../assets/SVG/reference_morphology.svg';


import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { convertUnderscoreToTitle } from '../../../utils/commonUtils';
import { useTranslation } from 'react-i18next';
import { getIUIDetails } from './IUIHelper';

interface SemenProcessingProps {
  cycle: string;
}

// Style constants to avoid creating new object references on each render
const inlineStyles = {
  errorMessageStyle: {
    marginTop: '2rem',
    textAlign: 'center' as const,
    fontWeight: 600,
    fontSize: '1.2rem',
    color: '#E17E61'
  },
  centeredErrorStyle: {
    textAlign: 'center' as const,
    fontWeight: 600,
    fontSize: '1.2rem',
    color: '#E17E61'
  },
  flexStartStyle: {
    display: 'flex',
    alignItems: 'start' as const,
    justifyContent: 'start' as const
  },
  normalFillStyle: { fill: '#47B35F' },
  abnormalFillStyle: { fill: '#CD1313' }
};

const IUIDetails: React.FC<SemenProcessingProps> = ({ cycle }) => {
  const [selectedSpermSource, setSelectedSpermSource] = React.useState('partner');
  const [sourceDetails, setSourceDetails] = React.useState(true);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const { t } = useTranslation('cycleOverview_config');

  useEffect(() => {
    getIUIDetails(cycle)
      .then((data) => {
        const filteredData = data;
        setFilteredData(filteredData);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
      });
  }, [cycle, sourceDetails]);

  const handleSpermSourceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSource = event.target.value;
    setSelectedSpermSource(newSource);
    setSourceDetails(newSource === 'partner');
  };
  const selectedData = sourceDetails ? filteredData[0] : filteredData[1];

  if (!filteredData.length || !selectedData) {
    return (
      <div className={styles.container}>
        <Grid container spacing={3} justifyContent="start" alignItems="center">
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="spermSource"
                name="spermSource"
                row
                value={selectedSpermSource}
                onChange={handleSpermSourceChange}
              >
                <FormControlLabel
                  value="partner"
                  control={<Radio sx={{ '&.Mui-checked': { color: '#E17E61' } }} />}
                  label={t('Partner')}
                  className={styles.radioLabel}
                />
                <FormControlLabel
                  value="spermDonor"
                  control={<Radio sx={{ '&.Mui-checked': { color: '#E17E61' } }} />}
                  label={t('SpermDonor')}
                  className={styles.radioLabel}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <div style={inlineStyles.errorMessageStyle}>
          {t('NoDataAvailable')}
        </div>
      </div>
    );
  }


  return (
    <div className={styles.container}>
      <Grid container spacing={3} justifyContent="start" alignItems="center">
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="spermSource"
              name="spermSource"
              row
              value={selectedSpermSource}
              onChange={handleSpermSourceChange}
            >
              <FormControlLabel
                value="partner"
                control={<Radio sx={{ '&.Mui-checked': { color: '#E17E61' } }} />}
                label={t('Partner')}
                className={styles.radioLabel}
              />
              <FormControlLabel
                value="spermDonor"
                control={<Radio sx={{ '&.Mui-checked': { color: '#E17E61' } }} />}
                label={t('SpermDonor')}
                className={styles.radioLabel}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      {/* Headers Row */}
      <Grid container spacing={3} justifyContent="start" alignItems="center" className="mt-4">
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <strong className={styles.headerTextStyle}>{t('Date')}</strong>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <strong className={styles.headerTextStyle}>{t('AndrologistName')}</strong>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <strong className={styles.headerTextStyle}>{t('TypeOfSperm')}</strong>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <strong className={styles.headerTextStyle}>{t('SemenPreparationMethod')}</strong>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <strong className={styles.headerTextStyle}>{t('SampleCollectedAt')}</strong>
          </div>
        </Grid>
      </Grid>
      {/* Values Row */}
      <Grid container spacing={3} justifyContent="start" alignItems="center">
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <span className={styles.customTextStyle}>{selectedData?.date || '-'}</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <span className={styles.customTextStyle}>{convertUnderscoreToTitle(selectedData?.done_by_name) || '-'}</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <span className={styles.customTextStyle}>{convertUnderscoreToTitle(selectedData?.sperm_type_label) || '-'}</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <span className={styles.customTextStyle}>{convertUnderscoreToTitle(selectedData?.semen_preparation_method_label) || '-'}</span>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className={styles.textField} style={inlineStyles.flexStartStyle}>
            <span className={styles.customTextStyle}>
              {selectedData?.sample_collected_at === 'INHOUSE'
                ? t('in_house')
                : (selectedData?.sample_collected_at === 'OUTSIDE' || selectedData?.sample_collected_at === 'OUTHOUSE')
                  ? t('outside')
                  : '-'}
            </span>
          </div>
        </Grid>
      </Grid>

      <hr className="mt-4" />

      {(selectedData &&
        (selectedData.post_total_sperm_count === undefined || selectedData.post_total_sperm_count === null) &&
        (selectedData.post_total_motility === undefined || selectedData.post_total_motility === null)) ? (
          <div className={styles.container}>
            <div style={inlineStyles.centeredErrorStyle}>
              {t('PreparationAssessmentNotDone')}
            </div>
          </div>
        ) : (
          <Grid container spacing={3} justifyContent="start" alignItems="center" className="mt-4">
            {/* First Grid item: Sperm Count */}
            {selectedData && selectedData.post_total_sperm_count != null &&(
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div className={`${styles.boxContainer}`}>
                  <strong className={styles.headerTextStyleimg}>{t('SpermCount')}</strong>
                  <Grid container spacing={2} alignItems="center">
                    {/* Sperm Count Section */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className={styles.textField}>
                        <div className={`${styles.containerprofile} mt-4`}>
                          <span className={styles.semenProcessContainer}>
                            {selectedData.post_total_sperm_count < 33 ? (
                              <LowSpermCount width="10rem" height="10rem" />
                            ) : selectedData.post_total_sperm_count >= 33 && selectedData.post_total_sperm_count <= 46 ? (
                              <NormalSpermCount width="10rem" height="10rem" />
                            ) : (
                              <HighSpermCount width="10rem" height="10rem" />
                            )}
                          </span>
                          <div className={styles.textContainer}>
                            <p className={styles.name}>
                              {selectedData.source_name || '-'}
                              {selectedData.post_total_sperm_count ? (
                                <>
                                  {selectedData.post_total_sperm_count >= 33 && selectedData.post_total_sperm_count <= 46 ? (
                                    <NormalImg style={inlineStyles.normalFillStyle} />
                                  ) : (
                                    <AbnormalImg style={inlineStyles.abnormalFillStyle} />
                                  )}
                                </>
                              ) : null}
                            </p>
                            <p className={`${styles.hello} mt-2`}>
                              {t('SpermCountIdentified', {
                                status: selectedData.post_total_sperm_count >= 33 && selectedData.post_total_sperm_count <= 46 ? t('normal') : t('abnormal'),
                                value: selectedData.post_total_sperm_count ?? '-',
                              })}
                            </p>
                            <p
                              className={styles.funnyText}
                              style={{
                                color:
                                    selectedData.post_total_sperm_count >= 33 && selectedData.post_total_sperm_count <= 46
                                      ? '#47B35F'
                                      : '#CD1313',
                              }}
                            >
                              {t('SpermCountValue', { value: selectedData.post_total_sperm_count ?? '-' })}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Grid>

                    {/* Reference Section */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className={styles.textField}>
                        <div className={`${styles.containerprofile} mt-4`}>
                          <span className={styles.semenProcessContainer}>
                            <SpermCountRefrenceImage width="10rem" height="10rem" />
                          </span>
                          <div className={styles.textContainer}>
                            <p className={styles.name}>{t('Reference')}</p>
                            <p className={`${styles.hello} mt-2`}>
                              {t('SpermCountReferenceText')}
                            </p>
                            <p className={styles.funnyTextrefrence}>{t('SpermCountReferenceRange')}</p>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            )}


            {/* Second Grid item: Sperm Total Motility */}
            {selectedData && selectedData.post_total_motility && (
              <Grid item xs={12} lg={6}>
                <div className={`${styles.boxContainer}`}>
                  <strong className={styles.headerTextStyleimg}>{t('SpermTotalMotility')}</strong>
                  <Grid container spacing={2} alignItems="center">
                    {/* Sperm Total Motility Section */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className={styles.textField}>
                        <div className={`${styles.containerprofile} mt-4`}>
                          <span className={styles.semenProcessContainer}>
                            {selectedData.post_total_motility > 40 ? (
                              <NormalSpermMotility width="10rem" height="10rem" />
                            ) : (
                              <AbNormalSpermMotility width="10rem" height="10rem" />
                            )}
                          </span>
                          <div className={styles.textContainer}>
                            <p className={styles.name}>
                              {selectedData.source_name || '-'}
                              {selectedData.post_total_motility ? (
                                <>
                                  {selectedData.post_total_motility > 40 ? (
                                    <NormalImg style={inlineStyles.normalFillStyle} />
                                  ) : (
                                    <AbnormalImg style={inlineStyles.abnormalFillStyle} />
                                  )}
                                </>
                              ) : null}
                            </p>
                            <p className={`${styles.hello} mt-2`}>
                              {t('SpermMotilityIdentified', {
                                status: selectedData.post_total_motility > 40 ? t('normal') : t('abnormal'),
                                value: selectedData.post_total_motility ?? '-',
                              })}
                            </p>
                            <p
                              className={`${styles.funnyText} mt-2`}
                              style={{
                                color: selectedData.post_total_motility > 40 ? '#47B35F' : '#CD1313',
                              }}
                            >
                              {t('SpermMotilityValue', { value: selectedData.post_total_motility ?? '-' })}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Grid>

                    {/* Reference Section */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className={styles.textField}>
                        <div className={`${styles.containerprofile} mt-4`}>
                          <span className={styles.semenProcessContainer}>
                            <SpermMotalityRefImg width="10rem" height="10rem" />

                          </span>
                          <div className={styles.textContainer}>
                            <p className={styles.name}>{t('Reference')}</p>
                            <p className={`${styles.hello} mt-2`}>
                              {t('SpermMotilityReferenceText')}
                            </p>
                            <p className={styles.funnyTextrefrence}>{t('SpermMotilityReferenceRange')}</p>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>

            )}
            {/* <Grid item xs={12} sm={6} md={6} lg={6}>
          <div className={`${styles.boxContainer}`}>
            <strong className={styles.headerTextStyleimg}>Sperm Morphology</strong>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <div className={styles.textField}>
                  <div className={`${styles.containerprofile} mt-4`}>
                    <span className={styles.semenProcessContainer}>
                      <>
                        {filteredData[0].post_total_motility_count > 40 ? (
                          <NormalSpermMorphology width="10rem" height="10rem" />
                        ) : (
                          <AbNormalSpermMorphology width="10rem" height="10rem" />
                        )}
                      </>
                    </span>
                    <div className={styles.textContainer}>
                      <p className={styles.name}>
                        {filteredData.length > 0 ? filteredData[0].source_name : '-'}
                        {filteredData.length > 0 && filteredData[0].post_total_motility_count && (
                          <>
                            {filteredData[0].post_total_motility_count > 40 ? (
                              <NormalImg style={inlineStyles.normalFillStyle} />
                            ) : (
                              <AbnormalImg style={inlineStyles.abnormalFillStyle} />
                            )}
                          </>
                        )}
                      </p>
                      <p className={`${styles.hello} mt-2`}>
                        Your Total Sperm count has been identified <br />
                        as {filteredData.length > 0 && filteredData[0].post_total_motility_count > 40 ? 'normal' : 'abnormal'}, with a value of{' '}
                        {filteredData.length > 0 ? filteredData[0].post_total_motility_count : '-'} million/ejaculate.
                      </p>
                      <p
                        className={`${styles.funnyText} mt-2`}
                        style={{
                          color: filteredData.length > 0 && filteredData[0].post_total_motility_count > 40 ? '#47B35F' : '#CD1313',
                        }}
                      >
                        {filteredData.length > 0 ? filteredData[0].post_total_motility_count : '-'} million/ejaculate
                      </p>
                    </div>
                  </div>
                </div>

              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={6}>
                <div className={styles.textField}>
                  <div className={`${styles.containerprofile} mt-4`}>
                    <span className={styles.semenProcessContainer}>
                      <SpermMorphologyRefImg width="10rem" height="10rem" />

                    </span>
                    <div className={styles.textContainer}>
                      <p className={styles.name}>Reference</p>
                      <p className={`${styles.hello} mt-2`}>
                        The normal Sperm total motility typically should be greater than 40%.
                      </p>
                      <p className={styles.funnyTextrefrence}>Greater than 40%</p>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid> */}


          </Grid>
        )}

    </div>
  );
};

export default IUIDetails;
